import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { jspGlobals } from '../common/jspGlobals';
import * as constants from '../common/constants';

/**
 * Reads JSP globals once on initial render via the centralized jspGlobals snapshot.
 *
 * Returns: { jspVariables, launcher, launcherConfig, panelStyle }
 */
const useJspVariables = () => {
    const dispatch = useDispatch();

    const [jspVariables] = useState(() => {
        const jspValues = {
            ...jspGlobals,
            showRememberMe: true,
            isAppDropDownVisible: true,
        };

        if (jspValues.jspPage === 'LOGIN') {
            jspValues.appDropDownVisible = false;
        }

        // Dispatch passwordless OTP flag if both enabled and preferred
        if (jspValues.jspPasswordLessEnabled && jspValues.jspPasswordLessPreferred) {
            dispatch({ type: 'AUTH_MODE_STATE', data: { requiresPasswordLessOtp: true } });
        }

        return jspValues;
    });

    const [launcher] = useState(() => {
        return jspGlobals.jspLoginApp === constants.APP_LAUNCHER;
    });

    const [launcherConfig] = useState(() => {
        if (typeof window.jspLauncherConfig !== 'undefined' && window.jspLauncherConfig) {
            const config = JSON.parse(window.jspLauncherConfig);
            return { ...config, overflow: 'auto', 'box-shadow': 'unset', border: 0 };
        }
        return {};
    });

    const panelStyle = launcher
        ? { }
        : { padding: '40px', border: '1px solid #000000' };

    return {
        jspVariables,
        launcher,
        launcherConfig,
        panelStyle,
    };
};

export default useJspVariables;
